export default __webpack_public_path__ + "static/media/icon192.ec908fb8.png";